import breakpoints from "../../breakpoints";
import { ComponentsOverrides, Theme } from "@mui/material";

const dialogContent = (): ComponentsOverrides<Theme>["MuiDialogContent"] => ({
	root: {
		paddingTop: "2rem",
		paddingLeft: "var(--panelOutSpacingHor)",
		paddingRight: "var(--panelOutSpacingHor)",
		paddingBottom: "2rem",
		display: "flex",
		flexDirection: "column",
		minHeight: 0,
		"& > .dialog-content-in": {
			display: "flex",
			flexDirection: "column",
			minHeight: 0,
		},

		"& .panelIn": {
			marginLeft: 0,
			marginRight: 0,
		},
		[`@media (max-width:${breakpoints.values.md - 0.05}px)`]: {
			paddingLeft: "calc(var(--panelOutSpacingHor) + var(--panelInSpacing))",
			paddingRight: "calc(var(--panelOutSpacingHor) + var(--panelInSpacing))",
			"& .panelIn": {
				marginLeft: "calc(var(--panelInSpacing)*-1)",
				marginRight: "calc(var(--panelInSpacing)*-1)",
			},
		},
	},
});

export default dialogContent;
